import i18next from 'i18next';
import * as yup from 'yup';
import moment from 'moment';

import { languages } from './languages';
import yupLocaleI18n from './yupLocaleI18n';

import 'moment/locale/de';
import 'moment/locale/en-gb';

i18next.init(languages);

const applyValidationLocale = (lng: string) => {
  yup.setLocale(yupLocaleI18n);
  moment.locale(lng.startsWith('en') ? 'en-gb' : 'de');
};

applyValidationLocale(i18next.language || 'de');
i18next.on('languageChanged', applyValidationLocale);

export default yup;
